lmApp
  .factory('PlanService', ['$rootScope', '$q', function ($rootScope, $q) {

    var service = {};

    /**
     * Get offers from server
     * @returns {*}
     */
    service.GetPlans = function () {
      var deferred = $q.defer();

      lh.common.request.get('collection/offer/query' + '?t=' + Date.now())
        .then(function (response) {

          deferred.resolve(response.collection.filter(function (plan) {

            return plan.type === 'subscription';
          }));

        }, function (reason) {

          reason.url = 'collection/offer/query' + '?t=' + Date.now();
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * Update offer status [is_active]
     * @param offer
     * @returns {*}
     * @constructor
     */
    service.UpdatePlanStatus = function (offer) {
      var deferred = $q.defer();

      var data = {
        offer_id: offer.id,
        is_active: +offer._PrivateData.is_active
      };

      lh.common.request.post('offer/mgmt/update', data)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'offer/mgmt/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * Update offers options
     * @returns {*}
     */
    service.UpdatePlan = function (offer) {
      var deferred = $q.defer();

      offer.billing_params.currency = offer._PrivateData.billing_params_currency.id;
      offer.billing_params.price = parseInt(offer._PrivateData.billing_params_price * 100, 10) || 0;

      offer.right_params = {};

      if (!offer._PrivateData.right_params_duration) {
        offer.right_params.duration = 0;
      } else {
        offer.right_params.duration = parseInt(offer._PrivateData.right_params_duration, 10) || 0;
      }

      if (offer._PrivateData.right_params_duration_unit) offer.right_params.duration_unit = offer._PrivateData.right_params_duration_unit.id;

      if (offer._PrivateData.isTrialAvailable) {
        offer.right_params.trial_duration = parseInt(offer._PrivateData.right_params_trial_duration, 10) || 0;
        offer.right_params.trial_duration_unit = (offer._PrivateData.right_params_trial_duration_unit) ? offer._PrivateData.right_params_trial_duration_unit.id : undefined;
      }

      if (offer._PrivateData.type === 'transactional-own') {
        offer.right_params.duration = 0;
      }

      if (offer._PrivateData.type.indexOf('transactional') !== -1) {
        offer._PrivateData.type = 'transactional';
      }

      var data = {
        offer_id: offer.id,
        name: offer._PrivateData.name,
        type: offer._PrivateData.type,
        start_time: offer._PrivateData.start_time.unix(),
        end_time: offer._PrivateData.end_time.unix(),
        priority: offer._PrivateData.priority,
        billing_params: JSON.stringify(offer.billing_params),
        is_active: +offer._PrivateData.is_active
      };

      if (!_.isEmpty(offer.right_params)) {
        data.right_params = JSON.stringify(offer.right_params);
      }

      lh.common.request.post('offer/mgmt/update', data)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'offer/mgmt/update';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * Create offers options
     * @returns {*}
     */
    service.CreatePlan = function (offer) {
      var deferred = $q.defer();

      offer.billing_params.currency = offer._PrivateData.billing_params_currency.id;
      offer.billing_params.price = parseInt(offer._PrivateData.billing_params_price * 100, 10) || 0;

      if (!offer._PrivateData.right_params_duration) {
        offer.right_params.duration = 0;
      } else {
        offer.right_params.duration = parseInt(offer._PrivateData.right_params_duration, 10) || 0;
      }

      if (offer._PrivateData.right_params_duration_unit) offer.right_params.duration_unit = offer._PrivateData.right_params_duration_unit.id;

      if (offer._PrivateData.isTrialAvailable) {
        offer.right_params.trial_duration = parseInt(offer._PrivateData.right_params_trial_duration, 10) || 0;
        offer.right_params.trial_duration_unit = (offer._PrivateData.right_params_trial_duration_unit) ? offer._PrivateData.right_params_trial_duration_unit.id : undefined;
      }

      if (offer._PrivateData.type === 'transactional-own') {
        offer.right_params.duration = 0;
      }

      if (offer._PrivateData.type.indexOf('transactional') !== -1) {
        offer._PrivateData.type = 'transactional';
      }

      var data = {
        name: offer._PrivateData.name,
        type: offer._PrivateData.type,
        start_time: offer._PrivateData.start_time.unix(),
        end_time: offer._PrivateData.end_time.unix(),
        priority: offer._PrivateData.priority,
        billing_params: JSON.stringify(offer.billing_params),
        right_params: JSON.stringify(offer.right_params),
        is_active: +offer._PrivateData.is_active
      };

      lh.common.request.post('offer/mgmt/create', data)
        .then(function (response) {
          deferred.resolve(response.offer);
        }, function (reason) {
          reason.url = 'offer/mgmt/create';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * Create offers options
     * @returns {*}
     */
    service.DeletePlan = function (ext_offer) {
      var deferred = $q.defer();

      var data = {
        offer_id: ext_offer.id
      };

      lh.common.request.post('offer/mgmt/delete', data)
        .then(function (response) {
          deferred.resolve();
        }, function (reason) {
          reason.url = 'offer/mgmt/delete';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.AddAssetToPlan = function (assets, offer) {
      var deferred = $q.defer();

      var data = {
        offer_id: offer.id,
        asset_id: assets.join(',')
      };

      lh.common.request.post('offer/mgmt/asset/assoc')
        .then(function (response) {
          deferred.resolve();
        }, function (reason) {
          reason.data = data;
          reason.url = 'offer/mgmt/asset/assoc';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.AddAsset = function (offers_ids, assets_ids) {
      var deferred = $q.defer();

      var data = {
        offer_id: offers_ids.join(','),
        asset_id: assets_ids.join(',')
      };

      lh.common.request.post('offer/mgmt/asset/assoc', data)
        .then(function (response) {
          deferred.resolve();
        }, function (reason) {
          reason.data = data;
          reason.url = 'offer/mgmt/asset/assoc';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.RemoveAsset = function (offers_ids, assets_ids) {
      var deferred = $q.defer();

      var data = {
        offer_id: offers_ids.join(','),
        asset_id: assets_ids.join(',')
      };

      lh.common.request.post('offer/mgmt/asset/deassoc', data)
        .then(function (response) {
          deferred.resolve();
        }, function (reason) {
          reason.data = data;
          reason.url = 'offer/mgmt/asset/deassoc';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    return service;
  }]);
